// CategoryTreeView.js
import React, { useState } from 'react';

const CategoryTreeView = ({ 
  categories, 
  selectedEquipmentType, 
  onEquipmentTypeSelect,
  searchQuery = ""
}) => {
  const [expandedCategories, setExpandedCategories] = useState({});
  const [expandedSubcategories, setExpandedSubcategories] = useState({});

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const toggleSubcategory = (subcategoryId) => {
    setExpandedSubcategories(prev => ({
      ...prev,
      [subcategoryId]: !prev[subcategoryId]
    }));
  };

  const filterEquipmentTypes = (equipmentTypes, query) => {
    if (!query) return equipmentTypes;
    return equipmentTypes.filter(equipment => 
      equipment.label.toLowerCase().includes(query.toLowerCase())
    );
  };

  const hasMatchingEquipment = (subcategory, query) => {
    if (!query) return true;
    return subcategory.equipment_types.some(equipment =>
      equipment.label.toLowerCase().includes(query.toLowerCase())
    );
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 max-h-96 overflow-y-auto">
      {Object.entries(categories).map(([categoryKey, category]) => {
        const hasMatches = !searchQuery || Object.values(category.subcategories).some(
          subcategory => hasMatchingEquipment(subcategory, searchQuery)
        );

        if (!hasMatches) return null;

        return (
          <div key={categoryKey} className="space-y-1 mb-3">
            <div 
              className="flex items-center cursor-pointer text-sm text-gray-700 hover:text-gray-900 py-1"
              onClick={() => toggleCategory(categoryKey)}
            >
              <span className="mr-2 text-xs">
                {expandedCategories[categoryKey] ? '▼' : '▶'}
              </span>
              <span className="font-medium">{category.label}</span>
            </div>

            {expandedCategories[categoryKey] && (
              <div className="pl-4 space-y-2">
                {Object.entries(category.subcategories).map(([subcategoryKey, subcategory]) => {
                  const filteredEquipment = filterEquipmentTypes(subcategory.equipment_types, searchQuery);
                  
                  if (filteredEquipment.length === 0) return null;

                  return (
                    <div key={subcategoryKey}>
                      <div 
                        className="flex items-center cursor-pointer text-sm text-gray-600 hover:text-gray-800 py-1"
                        onClick={() => toggleSubcategory(subcategoryKey)}
                      >
                        <span className="mr-2 text-xs">
                          {expandedSubcategories[subcategoryKey] ? '▼' : '▶'}
                        </span>
                        <span className="font-medium">{subcategory.label}</span>
                        <span className="ml-auto text-xs text-gray-400">
                          ({filteredEquipment.length})
                        </span>
                      </div>

                      {expandedSubcategories[subcategoryKey] && (
                        <div className="pl-4 mt-1 space-y-1">
                          {filteredEquipment.map((equipment) => (
                            <div
                              key={equipment.id}
                              onClick={() => onEquipmentTypeSelect(equipment)}
                              className={`text-sm px-2 py-1 rounded cursor-pointer transition-colors ${
                                selectedEquipmentType?.id === equipment.id
                                  ? "bg-blue-200 text-blue-800 font-medium"
                                  : "text-gray-600 hover:bg-gray-200 hover:text-gray-800"
                              }`}
                            >
                              <span className="mr-2">🔧</span>
                              {equipment.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CategoryTreeView;